import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { useAuthStore } from '@/store/auth.store';
import type { ComplianceDashboardData } from '@/api/types/compliance-dashboard.types';

export function useComplianceDashboard() {
  const { tenantId, isAuthenticated } = useAuthStore();

  return useQuery({
    queryKey: ['dashboard', 'compliance', tenantId],
    queryFn: async (): Promise<ComplianceDashboardData> => {
      const { data } = await apiClient.get<{ data: ComplianceDashboardData }>('/dashboards/compliance');
      return data.data;
    },
    enabled: isAuthenticated,
    staleTime: 60_000,
  });
}
